module.exports = __webpack_public_path__ + "static/media/video-starting-convo-en.94c2728e.vtt";